import { ClassificationTag } from '@ui/tags';
import React from 'react';
import { When } from 'react-if';
export const AuditTrailAction = ({ action, classification }) => React.createElement("span", { className: 'audit-trail-action' },
    React.createElement(When, { condition: classification },
        React.createElement(ClassificationTag, { classification: classification })),
    action);
